// src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './pages/HomePage/HomePage';
import MealEntryForm from './pages/MealEntry/MealEntryForm';
import RegisterPage from './pages/Register/RegisterPage';
import LoginPage from './pages/LoginPage/LoginPage';
import SetupProfilePage from './pages/SetupProfilePage/SetupProfilePage';
import MealJournalPage from './pages/MealJournalPage/MealJournalPage';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import useRequireProfile from './hooks/useRequireProfile';
import HeaderNav from './components/HeaderNav';
import { Analytics } from '@vercel/analytics/react';
import FeaturesPage from "./pages/FeaturesPage/FeaturesPage";
import {Center, Spinner} from "@chakra-ui/react";
import WorkoutJournalPage from "./pages/WorkoutJournalPage/WorkoutJournalPage";
import MealPlannerPage from "./pages/MealPlannerPage/MealPlannerPage";
import DashboardPage from './pages/DashboardPage/DashboardPage'

// PublicRoute wrapper redirects to home if user is logged in
const PublicRoute = ({ children }) => {
    const { user, initialising } = useAuth();
    if (initialising) {
        return (
            <Center h="70vh">
                <Spinner size="x1" />
            </Center>
        )
    }
    return user ? <Navigate to="/" replace /> : children;
};

const AppRoutes = () => {
    const { user } = useAuth();
    useRequireProfile(user);

    return (
        <Routes>
            {/* Public Routes */}
            <Route path="/register" element={
                <PublicRoute>
                    <RegisterPage />
                </PublicRoute>
            } />
            <Route path="/login" element={
                <PublicRoute>
                    <LoginPage />
                </PublicRoute>
            } />
            <Route path="/features" element={<FeaturesPage />} />
            {/* Protected Routes */}
            <Route element={<ProtectedRoute />}>
                <Route path="/" element={user ? <DashboardPage /> : <HomePage />} />
                <Route path="/meal-entry" element={<MealEntryForm />} />
                <Route path="/setup-profile" element={<SetupProfilePage />} />
                <Route path="/meal-journal" element={<MealJournalPage />} />
                <Route path="/workout-journal" element={<WorkoutJournalPage />} />
                <Route path="/meal-planner" element={<MealPlannerPage />} />
            </Route>
        </Routes>
    );
};

const App = () => (
    <AuthProvider>
        <BrowserRouter>
            <HeaderNav />
            <AppRoutes />
        </BrowserRouter>
        <Analytics />
    </AuthProvider>
);

export default App;
